import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

interface AGBState extends BasePageState {}
interface AGBModel {}

export default class AGBPage extends Basepage<AGBState, AGBModel> {
  renderChild(): JSX.Element {
    return (
      <div id="AGB">
        Allgemeine Geschäftsbedingungen und Kundeninformationen
        <br />
        <br />
        I. Allgemeine Geschäftsbedingungen
        <br />
        <br />
        § 1 Grundlegende Bestimmungen
        <br />
        <br />
        (1) Die nachstehenden Geschäftsbedingungen gelten für Verträge, die Sie
        mit uns als Anbieter (Moluna GmbH) über die Internetseite
        www.buchbutler.de schließen, soweit nicht schriftlich zwischen den
        Parteien eine Abänderung vereinbart wird. Abweichende oder
        entgegenstehende Geschäftsbedingungen sind nur mit unserer
        ausdrücklichen Zustimmung wirksam.
        <br />
        <br />
        (2) Wir bieten unsere Produkte nur zum Kauf an, soweit Sie eine
        natürliche oder juristische Person oder eine rechtsfähige
        Personengesellschaft sind, die bei Abschluss des Rechtsgeschäfts in
        Ausübung ihrer gewerblichen oder selbständigen beruflichen Tätigkeit
        handelt (Unternehmer). Ein Vertragsabschluss mit Verbrauchern ist
        ausgeschlossen.
        <br />
        <br />
        § 2 Zustandekommen des Vertrages
        <br />
        <br />
        (1) Gegenstand des Vertrages ist der Verkauf von Waren. Die wesentlichen
        Merkmale der Ware finden sich im jeweiligen Angebot.
        <br />
        <br />
        (2) Bereits mit dem Einstellen des jeweiligen Produkts auf unserer
        Internetseite unterbreiten wir Ihnen ein verbindliches Angebot zum
        Abschluss eines Vertrages über das Online-Warenkorbsystem zu den im
        jeweiligen Angebot angegebenen Bedingungen. <br />
        <br />
        (3) Der Vertrag kommt über das Online-Warenkorbsystem wie folgt
        zustande: Die zum Kauf beabsichtigten Waren werden im "Warenkorb"
        abgelegt. Über die entsprechende Schaltfläche in der Navigationsleiste
        können Sie den "Warenkorb" aufrufen und dort jederzeit Änderungen
        vornehmen. Nach Aufrufen der Seite "Kasse" und der Eingabe der
        persönlichen Daten sowie der Zahlungs- und Versandbedingungen werden
        Ihnen abschließend die Bestelldaten als Bestellübersicht angezeigt.{' '}
        <br />
        <br />
        Soweit Sie als Zahlungsart ein Sofortzahl-System (z.B. PayPal / PayPal
        Express, Amazon-Payments, Sofortüberweisung) nutzen, werden Sie entweder
        auf die Bestellübersichtsseite in unserem Online-Shop geführt oder auf
        die Internetseite des Anbieters des Sofortzahl-Systems weitergeleitet.
        Erfolgt eine Weiterleitung zu dem jeweiligen Sofortzahl-System, nehmen
        Sie dort die entsprechende Auswahl bzw. Eingabe Ihrer Daten vor.
        Abschließend werden Ihnen auf der Internetseite des Anbieters des
        Sofortzahl-Systems oder nachdem Sie zurück in unseren Online-Shop
        geleitet wurden, die Bestelldaten als Bestellübersicht angezeigt. <br />
        <br />
        Vor Absenden der Bestellung haben Sie die Möglichkeit, die Angaben in
        der Bestellübersicht nochmals zu überprüfen, zu ändern (auch über die
        Funktion "zurück" des Internetbrowsers) bzw. die Bestellung abzubrechen.
        Mit dem Absenden der Bestellung über die entsprechende Schaltfläche
        erklären Sie rechtsverbindlich die Annahme des Angebotes, wodurch der
        Vertrag zustande kommt.
        <br />
        <br />
        (4) Sie können ferner ein verbindliches Vertragsangebot (Bestellung)
        telefonisch, per E-Mail, per Fax oder per Post abgeben. Die Annahme des
        Angebots (und damit der Vertragsabschluss) erfolgt bei Bestellung per
        Telefon sofort oder spätestens innerhalb von 5 Tagen durch Bestätigung
        in Textform (z.B. E-Mail), in welcher Ihnen die Ausführung der
        Bestellung oder Auslieferung der Ware bestätigt wird
        (Auftragsbestätigung). Sollten Sie innerhalb dieser Frist keine
        entsprechende Nachricht erhalten haben, sind Sie nicht mehr an Ihre
        Bestellung gebunden. Gegebenenfalls bereits erbrachte Leistungen werden
        in diesem Fall unverzüglich zurückerstattet. (5) Auf Anfrage erstellen
        wir Ihnen ein individuelles Angebot, welches Ihnen in Textform zugesandt
        wird und an das wir uns 5 Tage (soweit im jeweiligen Angebot keine
        andere Frist ausgewiesen ist) gebunden halten. Sie nehmen das Angebot
        mit Bestätigung in Textform an.
        <br />
        <br />
        (6) Die Abwicklung der Bestellung und Übermittlung aller im Zusammenhang
        mit dem Vertragsschluss erforderlichen Informationen erfolgt per E-Mail
        zum Teil automatisiert. Sie haben deshalb sicherzustellen, dass die von
        Ihnen bei uns hinterlegte E-Mail-Adresse zutreffend ist, der Empfang der
        E-Mails technisch sichergestellt und insbesondere nicht durch
        SPAM-Filter verhindert wird.
        <br />
        § 3 Preise, Zahlungsbedingungen und Versandkosten
        <br />
        (1) Die in den jeweiligen Angeboten angeführten Preise sowie die
        Versandkosten stellen Nettopreise dar. Sie beinhalten nicht die
        gesetzliche Mehrwertsteuer.
        <br />
        <br />
        (2) Die anfallenden Versandkosten sind nicht im Kaufpreis enthalten, sie
        werden gesondert berechnet, soweit nicht die versandkostenfreie
        Lieferung zugesagt ist. Nähere Einzelheiten finden sich unter einer
        entsprechend bezeichneten Schaltfläche auf unserer Internetpräsenz oder
        im jeweiligen Angebot.
        <br />
        <br />
        (3) Erfolgt die Lieferung in Länder außerhalb der Europäischen Union
        können von uns nicht zu vertretende weitere Kosten anfallen, wie z.B.
        Zölle, Steuern oder Geldübermittlungsgebühren (Überweisungs- oder
        Wechselkursgebühren der Kreditinstitute), die von Ihnen zu tragen sind.{' '}
        <br />
        <br />
        (4) Entstandene Kosten der Geldübermittlung (Überweisungs- oder
        Wechselkursgebühren der Kreditinstitute) sind von Ihnen in den Fällen zu
        tragen, in denen die Lieferung in einen EU-Mitgliedsstaat erfolgt, die
        Zahlung aber außerhalb der Europäischen Union veranlasst wurde.
        <br />
        <br />
        (5) Sie haben die unter einer entsprechend bezeichneten Schaltfläche auf
        unserer Internetpräsenz oder im jeweiligen Angebot ausgewiesenen
        Zahlungsmöglichkeiten. Soweit bei den einzelnen Zahlungsarten oder auf
        der Rechnung keine andere Zahlungsfrist angegeben ist, sind die
        Zahlungsansprüche aus dem geschlossenen Vertrag sofort zur Zahlung
        fällig. Der Abzug von Skonti ist nur zulässig, sofern im jeweiligen
        Angebot oder in der Rechnung ausdrücklich ausgewiesen.
        <br />
        <br />
        § 4 Lieferbedingungen
        <br />
        <br />
        (1) Die voraussichtliche Lieferfrist ist im jeweiligen Angebot
        angegeben. Liefertermine und Lieferfristen sind nur verbindlich, wenn
        sie von uns schriftlich bestätigt wurden. Bei der Zahlart Vorkasse per
        Überweisung erfolgt die Versendung der Ware erst nach Eingang des
        vollständigen Kaufpreises und der Versandkosten bei uns.
        <br />
        <br />
        (2) Sollte ein von Ihnen bestelltes Produkt wider Erwarten trotz
        rechtzeitigem Abschluss eines adäquaten Deckungsgeschäftes aus einem von
        uns nicht zu vertretenden Grund nicht verfügbar sein, werden Sie
        unverzüglich über die Nichtverfügbarkeit informiert und im Falle des
        Rücktritts etwa bereits geleistete Zahlungen unverzüglich erstattet.
        <br />
        <br />
        (3) Die Versendung erfolgt auf Ihre Gefahr. Sofern Sie es wünschen,
        erfolgt der Versand mit einer entsprechenden Transportversicherung,
        wobei die hierdurch entstehenden Kosten von Ihnen zu übernehmen sind.
        <br />
        <br />
        (4) Teillieferungen sind zulässig und können von uns selbstständig in
        Rechnung gestellt werden, sofern Sie hierdurch nicht mit Mehrkosten für
        den Versand belastet werden.
        <br />
        <br />
        § 5 Gewährleistung
        <br />
        <br />
        (1) Die Gewährleistungsfrist beträgt ein Jahr ab Ablieferung der Ware.
        Die Fristverkürzung gilt nicht:
        <br />
        <br />
        - für uns zurechenbare schuldhaft verursachte Schäden aus der Verletzung
        des Lebens, des Körpers oder der Gesundheit und bei vorsätzlich oder
        grob fahrlässig verursachten sonstigen Schäden;
        <br />
        - soweit wir den Mangel arglistig verschwiegen oder eine Garantie für
        die Beschaffenheit der Sache übernommen haben;
        <br />
        - bei Sachen, die entsprechend ihrer üblichen Verwendungsweise für ein
        Bauwerk verwendet worden sind und dessen Mangelhaftigkeit verursacht
        haben;
        <br />
        - bei gesetzlichen Rückgriffsansprüchen, die Sie im Zusammenhang mit
        Mängelrechten gegen uns haben.
        <br />
        <br />
        (2) Als Beschaffenheit der Sache gelten nur unsere eigenen Angaben und
        die Produktbeschreibung des Herstellers als vereinbart, nicht jedoch
        sonstige Werbung, öffentliche Anpreisungen und Äußerungen des
        Herstellers.
        <br />
        <br />
        (3) Bei Mängeln leisten wir nach unserer Wahl Gewähr durch Nachbesserung
        oder Nachlieferung. Schlägt die Mangelbeseitigung fehl, können Sie nach
        Ihrer Wahl Minderung verlangen oder vom Vertrag zurücktreten. Die
        Mängelbeseitigung gilt nach erfolglosem zweiten Versuch als
        fehlgeschlagen, wenn sich nicht insbesondere aus der Art der Sache oder
        des Mangels oder den sonstigen Umständen etwas anderes ergibt. Im Falle
        der Nachbesserung müssen wir nicht die erhöhten Kosten tragen, die durch
        die Verbringung der Ware an einen anderen Ort als den Erfüllungsort
        entstehen, sofern die Verbringung nicht dem bestimmungsgemäßen Gebrauch
        der Ware entspricht.
        <br />
        <br />
        § 6 Zurückbehaltungsrecht, Eigentumsvorbehalt
        <br />
        <br />
        (1) Ein Zurückbehaltungsrecht können Sie nur ausüben, soweit es sich um
        Forderungen aus demselben Vertragsverhältnis handelt.
        <br />
        <br />
        (2) Wir behalten uns das Eigentum an der Ware bis zum vollständigen
        Ausgleich aller Forderungen aus der laufenden Geschäftsbeziehung vor.
        Vor Übergang des Eigentums an der Vorbehaltsware ist eine Verpfändung
        oder Sicherheitsübereignung nicht zulässig.
        <br />
        <br />
        (3) Sie können die Ware im ordentlichen Geschäftsgang weiterverkaufen.
        Für diesen Fall treten Sie bereits jetzt alle Forderungen in Höhe des
        Rechnungsbetrages, die Ihnen aus dem Weiterverkauf erwachsen, an uns ab,
        wir nehmen die Abtretung an. Sie sind weiter zur Einziehung der
        Forderung ermächtigt. Soweit Sie Ihren Zahlungsverpflichtungen nicht
        ordnungsgemäß nachkommen, behalten wir uns allerdings vor, die Forderung
        selbst einzuziehen.
        <br />
        <br />
        (4) Bei Verbindung und Vermischung der Vorbehaltsware erwerben wir
        Miteigentum an der neuen Sache im Verhältnis des Rechnungswertes der
        Vorbehaltsware zu den anderen verarbeiteten Gegenständen zum Zeitpunkt
        der Verarbeitung.
        <br />
        <br />
        (5) Wir verpflichten uns, die Ihnen zustehenden Sicherheiten auf Ihr
        Verlangen insoweit freizugeben, als der realisierbare Wert unserer
        Sicherheiten die zu sichernde Forderung um mehr als 10% übersteigt. Die
        Auswahl der freizugebenden Sicherheiten obliegt uns.
        <br />
        <br />
        § 7 Rechtswahl, Erfüllungsort, Gerichtsstand
        <br />
        <br />
        (1) Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts.
        <br />
        <br />
        (2) Erfüllungsort sowie Gerichtsstand ist unser Sitz, soweit Sie
        Kaufmann, juristische Person des öffentlichen Rechts oder
        öffentlich-rechtliches Sondervermögen sind. Dasselbe gilt, wenn Sie
        keinen allgemeinen Gerichtsstand in Deutschland oder der EU haben.
        <br />
        <br />
        <br />
        <br />
        <br />
        II. Kundeninformationen
        <br />
        <br />
        1. Identität des Anbieters
        <br />
        <br />
        Moluna GmbH
        <br />
        Engberdingdamm 27
        <br />
        48268 Greven
        <br />
        Deutschland
        <br />
        Telefon: 02571/5698933
        <br />
        E-Mail: service@buchbutler.de
        <br />
        <br />
        <br />
        2. Informationen zum Zustandekommen des Vertrages
        <br />
        <br />
        Die technischen Schritte zum Vertragsschluss und der Vertragsschluss
        selbst, sowie die Korrekturmöglichkeiten erfolgen nach Maßgabe des § 2
        unserer Allgemeinen Geschäftsbedingungen (Teil I).
        <br />
        <br />
        3. Vertragssprache, Vertragstextspeicherung
        <br />
        <br />
        3.1. Vertragssprache ist deutsch.
        <br />
        <br />
        3.2. Der vollständige Vertragstext wird von uns nicht gespeichert. Vor
        Absenden der Bestellung oder der Anfrage können die Vertragsdaten über
        die Druckfunktion des Browsers ausgedruckt oder elektronisch gesichert
        werden. <br />
        <br />
        4. Verhaltenskodizes
        <br />
        <br />
        4.1. Wir haben uns dem Europäischen Verhaltenskodex unterworfen, der
        unter folgendem Link einsehbar ist:
        http://www.euro-label.com/kodex/index.html
        (http://www.euro-label.com/kodex/index.html).
        <br />
        <br />
        4.2. Wir haben uns den "s@fer-shopping"-Qualitätskriterien der TÜV SÜD
        Management Service GmbH unterworfen, die unter folgendem Link einsehbar
        sind:
        <br />
        https://www.safer-shopping.de/uploads/pdf/Anforderungskatalogsafershoppingv51.pdf
        (https://www.safer-shopping.de/uploads/pdf/Anforderungskatalogsafershoppingv51.pdf).
        <br />
        <br />
        Diese AGB und Kundeninformationen wurden von den auf IT-Recht
        spezialisierten Juristen des Händlerbundes erstellt und werden permanent
        auf Rechtskonformität geprüft. Die Händlerbund Management AG garantiert
        für die Rechtssicherheit der Texte und haftet im Falle von Abmahnungen.
        Nähere Informationen dazu finden Sie unter:
        https://www.haendlerbund.de/de/leistungen/rechtssicherheit/agb-service.
        (https://www.haendlerbund.de/de/leistungen/rechtssicherheit/agb-service)
        <br />
        <br />
        letzte Aktualisierung: 01.01.2022
      </div>
    );
  }
  initState(base: BasePageState): AGBState {
    let newState: AGBState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }

  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'AGB';
  }
  getBreadCrumb(): JSX.Element {
    return <span>AGB</span>;
  }
  getType(): string {
    return 'AGBPage';
  }
}
